module.exports = __webpack_public_path__ + "img/gift-velans.d3a3459.png";